export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    SCREEN_APP_ALL: function SCREEN_APP_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/screen-app/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    SCREEN_APP_CREATE: function SCREEN_APP_CREATE(data) {
      return request({
        url: '/api/screen-app/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SCREEN_APP_DETAIL: function SCREEN_APP_DETAIL(id) {
      return request({
        url: '/api/screen-app/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SCREEN_APP_UPDATE: function SCREEN_APP_UPDATE(data) {
      return request({
        url: '/api/screen-app/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    SCREEN_APP_DELETE: function SCREEN_APP_DELETE(id) {
      return request({
        url: '/api/screen-app/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    SCREEN_APP_SYNC: function SCREEN_APP_SYNC(data) {
      return request({
        url: '/api/screen-app/sync',
        method: 'post',
        data: data
      });
    }
  };
});